import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScDialog, ScToast } from '@intelipost-js/secure-components';

export default {
  getWarehouses({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query {
      warehouses {
        id
        official_name
        code
        federal_tax_payer_id
        address {
          zip_code
        }
      }
    }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { warehouses = [] } = data || {};
        commit('toggleLoading', false);
        commit('setWarehouses', warehouses);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getWarehouse({ commit }, id) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query(
      $id: Int!
    ) {
      warehouse(
        id: $id
      ) {
        id
        name
        official_name
        phone
        email
        federal_tax_payer_id
        state_tax_payer_id
        code
        reimbursement_code
        freight_payer_warehouse_address_id
        address {
          zip_code
          state_code
          street
          quarter
          number
          reference
          additional
          city
        }
      }
    }`, { id })
      .then((res) => {
        const { data = {} } = res || {};
        const { warehouse = {} } = data || {};

        commit('setWarehouse', warehouse);
        commit('toggleLoading', false);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  createWarehouse({ commit }, warehouse) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $name: String!
      $official_name: String!
      $phone: String
      $email: String
      $federal_tax_payer_id: String!
      $state_tax_payer_id: String
      $address: AddressInput!
      $code: String!
      $reimbursement_code: String
      $freight_payer_warehouse_address_id: ID
    ) {
      createWarehouse (
        name: $name
        official_name: $official_name
        phone: $phone
        email: $email
        federal_tax_payer_id: $federal_tax_payer_id
        state_tax_payer_id: $state_tax_payer_id
        address: $address
        code: $code
        reimbursement_code: $reimbursement_code
        freight_payer_warehouse_address_id: $freight_payer_warehouse_address_id
      ) {
        id
      }
    }`, warehouse)
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('Centro de distribuição criado');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  updateWarehouse({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
      $name: String
      $official_name: String
      $phone: String
      $email: String
      $federal_tax_payer_id: String
      $state_tax_payer_id: String
      $address: AddressInput
      $code: String
      $reimbursement_code: String
      $freight_payer_warehouse_address_id: ID
    ) {
    updateWarehouse (
      id: $id
      name: $name
      official_name: $official_name
      phone: $phone
      email: $email
      federal_tax_payer_id: $federal_tax_payer_id
      state_tax_payer_id: $state_tax_payer_id
      address: $address
      code: $code
      reimbursement_code: $reimbursement_code
      freight_payer_warehouse_address_id: $freight_payer_warehouse_address_id
    ) {
      id
    }
  }`, params)
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('Centro de distribuição atualizado');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  removeWarehouse({ commit, dispatch }, warehouse) {
    const {
      id,
      official_name,
    } = warehouse;

    ScDialog.confirm({
      title: 'Remover centro de distribuição',
      message: `Tem certeza que deseja remover o centro de distribuição <strong>${official_name}</strong>?`,
      confirmText: 'Remover',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('toggleLoading', true);
        return GraphQlClient.mutation(`
          mutation ($id: Int!) {
            removeWarehouse(id: $id) {
              id
            }
          }`, { id })
          .then(() => dispatch('getWarehouses'))
          .then((res) => {
            commit('toggleLoading', false);
            ScToast.success(`${official_name} removida com sucesso.`);
            return Promise.resolve(res);
          })
          .catch((err) => {
            commit('toggleLoading', false);
            return Promise.reject(err);
          });
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/warehouses/store/actions.js